import e from "react";
import { TrendingUp as t, Grid as o, Briefcase as a, Money as r, ConfiguracaoDeServico as l } from "@olxbr/ds-icons";
const i = [{
  image: e.createElement(t, {
    color: "var(--color-neutral-120)",
    width: "16px",
    height: "16px"
  }),
  title: "Performance dos an\xFAncios",
  link: "https://planoprofissional.olx.com.br/performance",
  objectDetail: "performance",
  isNew: !0
}, {
  image: e.createElement(o, {
    color: "var(--color-neutral-120)",
    width: "16px",
    height: "16px"
  }),
  title: "Meus an\xFAncios",
  link: "https://conta.olx.com.br/anuncios",
  objectDetail: "my_ads"
}, {
  image: e.createElement(a, {
    color: "var(--color-neutral-120)",
    width: "16px",
    height: "16px"
  }),
  title: "Meu plano profissional",
  link: "https://planoprofissional.olx.com.br/",
  objectDetail: "my_plan"
}, {
  image: e.createElement(r, {
    color: "var(--color-neutral-120)",
    width: "16px",
    height: "16px"
  }),
  title: "Gerenciar pagamentos",
  link: "https://conta.olx.com.br/pagamentos",
  objectDetail: "payment_central"
}, {
  image: e.createElement(l, {
    color: "var(--color-neutral-120)",
    width: "16px",
    height: "16px"
  }),
  title: "Servi\xE7os",
  link: "https://autos-marketplace.olx.com.br/",
  objectDetail: "autos_marketplace"
}];
export { i as tileLinks };